import { Comment } from 'types'
import { sendToApi } from 'api/client'

export interface NewComment {
  layer_id?: string | null
  comment: Comment['comment']
  commentable_id?: Comment['commentable_id']
  commentable_type?: Comment['commentable_type']
  uuid?: Comment['uuid']
}

interface UpdateCommentPayload {
  comment?: string
  html_comment?: string
  title?: string
}

export const CommentClient = {
  getArticleComments: (id: string, articlePassword: string | null = null) => {
    return sendToApi<{ comments: Comment[] }>(`/articles/${id}/comments`, {
      params: {
        password: articlePassword,
      },
    })
  },
  createComment: (
    comment: NewComment,
    mentioned_users: number[] = [],
    anonymous_user_display_name?: string,
    user_id?: string,
    isRichText = false,
  ) => {
    return sendToApi<{ comment: Comment }>(`/comments`, {
      method: 'POST',
      body: {
        comment: {
          ...comment,
          html_comment: isRichText ? comment.comment : null,
        },
        mentioned_users,
        anonymous_user_display_name,
        user_id,
      },
    })
  },

  toggleCommentReaction: (id: number, reaction: string) => {
    return sendToApi<{ comment: Comment }>(`/comments/${id}/toggle_reaction`, {
      method: 'POST',
      body: { reaction },
    })
  },

  markCommentAsRead: (id: number) => {
    return sendToApi<{ comment: Comment }>(`/comments/${id}/mark_as_read`, {
      method: 'PUT',
    })
  },

  updateComment: (id: number, commentBody: UpdateCommentPayload, mentionedUsers: number[] = [], isRichText = false) => {
    const payload = { ...commentBody }
    if (isRichText) {
      payload.html_comment = commentBody.comment
    }
    return sendToApi<{ comment: Comment }>(`/comments/${id}`, {
      method: 'PUT',
      body: {
        comment: payload,
        mentioned_users: mentionedUsers,
      },
    })
  },

  resolveComment: (id: number) => {
    return sendToApi<void>(`/comments/${id}/resolve`, { method: 'PUT' })
  },

  bulkResolveComments: (comments: number[] = []) => {
    return sendToApi<void>(`/comments/bulk_resolve`, {
      method: 'POST',
      body: { comments_ids: comments },
    })
  },

  bulkDestroyComments: (articleId: string, layerId: string, comments: number[] = []) => {
    return sendToApi<void>(`/articles/${articleId}/layers/${layerId}/comments/bulk_destroy`, {
      method: 'POST',
      body: { comments_ids: comments },
    })
  },

  unresolveComment: (id: number) => {
    return sendToApi<void>(`/comments/${id}/unresolve`, { method: 'PUT' })
  },

  deleteComment: (id: number, trackArticleUpdate: boolean = false) => {
    return sendToApi<void>(`/comments/${id}`, {
      method: 'DELETE',
      body: { track_article_update: trackArticleUpdate },
    })
  },

  toggleImportance: (id: number) => {
    return sendToApi<void>(`/comments/${id}/toggle_importance`, {
      method: 'PUT',
    })
  },
}
